module.exports = __webpack_public_path__ + "images/imageBackground3.1c0c98f2.png";